import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { Cusip, LocalDate, Ticker, } from "../../Types";
import ValidationError from "../../ZodError";
import { SecuritiesRemoved, SecurityReplacements } from "../Shared";
const Security = z.object({
    name: z.string(),
    percent: z.string(), // number in string format `"0.37"`
    ticker: Ticker,
    cusip: Cusip,
});
export const AssetClass = z.custom((val) => typeof val === "string");
export const AssetClassCategory = z.custom((val) => typeof val === "string");
const Breakdown = z.object({
    category: AssetClassCategory,
    percent: z.number(),
    securities: Security.array(),
});
const PortfolioAssetClassBreakdown = z.record(AssetClass, Breakdown);
const PortfolioCategoryBreakdown = z.record(AssetClass, z.number());
export const Taxlot = z.object({
    accrual: z.number(),
    buyDate: LocalDate, // Date in "YYYY-MM-DD"
    buyPrice: z.number(),
    cusip: Cusip,
    marketValue: z.number(),
    quantity: z.number(),
    ticker: Ticker.nullable(),
});
const PortfolioAssetClassBreakdownArr = PortfolioAssetClassBreakdown.array();
export const FinMasonBreakdown = z.object({
    portfolioAssetClassBreakdown: PortfolioAssetClassBreakdownArr.nullable(),
    portfolioCategoryBreakdown: PortfolioCategoryBreakdown.nullable(),
    securityReplacements: SecurityReplacements.nullable(),
    securitiesRemoved: SecuritiesRemoved.nullable(),
});
export const GetHoldingsRes = z.object({
    finmasonHoldingsBreakdown: FinMasonBreakdown,
    taxLots: Taxlot.array(),
});
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v2/group/${accountGroupId}/get-all-holdings`
        : `https://middleware.uat.farther.com/account-groups/v2/group/${accountGroupId}/get-all-holdings`;
};
export default async function getHoldings(accountGroupId, config) {
    const { data } = await axios.get(url(accountGroupId), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = GetHoldingsRes.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getHoldings returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getHoldings.js.map